import React, { useRef, useState, useEffect } from "react";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Button } from "antd";
import "./HeaderCarousel.scss";

const foodItems = [
  { name: "Pizza", image: "https://source.unsplash.com/124x130/?pizza" },
  { name: "Burger", image: "https://source.unsplash.com/124x130/?burger" },
  { name: "Pasta", image: "https://source.unsplash.com/124x130/?pasta" },
  { name: "Ice Cream", image: "https://source.unsplash.com/124x130/?icecream" },
  { name: "Sandwich", image: "https://source.unsplash.com/124x130/?sandwich" },
  { name: "Fries", image: "https://source.unsplash.com/124x130/?fries" },
  { name: "Sushi", image: "https://source.unsplash.com/124x130/?sushi" },
  { name: "Pizza", image: "https://source.unsplash.com/124x130/?pizza" },
  { name: "Burger", image: "https://source.unsplash.com/124x130/?burger" },
  { name: "Pasta", image: "https://source.unsplash.com/124x130/?pasta" },
  { name: "Ice Cream", image: "https://source.unsplash.com/124x130/?icecream" },
  { name: "Sandwich", image: "https://source.unsplash.com/124x130/?sandwich" },
  { name: "Fries", image: "https://source.unsplash.com/124x130/?fries" },
  { name: "Sushi", image: "https://source.unsplash.com/124x130/?sushi" },
];

const HeaderCarousel = () => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const updateScrollButtons = () => {
    if (!scrollRef.current) return;
    const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
    setCanScrollLeft(scrollLeft > 0);
    setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 1);
  };

  const scrollLeft = () => {
    if (!scrollRef.current) return;
    scrollRef.current.scrollBy({ left: -600, behavior: "smooth" });
  };

  const scrollRight = () => {
    if (!scrollRef.current) return;
    scrollRef.current.scrollBy({ left: 600, behavior: "smooth" });
  };

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    updateScrollButtons(); // Check on mount
    el.addEventListener("scroll", updateScrollButtons);
    window.addEventListener("resize", updateScrollButtons);

    return () => {
      el.removeEventListener("scroll", updateScrollButtons);
      window.removeEventListener("resize", updateScrollButtons);
    };
  }, []);

  return (
    <div style={{ position: "relative", padding: "20px 0px" }}>
      <div className="header-text">What’s on your mind?</div>

      <div style={{ position: "absolute", top: 20, right: 10, zIndex: 1 }}>
        <Button
          shape="circle"
          icon={<LeftOutlined />}
          style={{ marginRight: 8 }}
          onClick={scrollLeft}
          disabled={!canScrollLeft}
        />
        <Button
          shape="circle"
          icon={<RightOutlined />}
          onClick={scrollRight}
          disabled={!canScrollRight}
        />
      </div>

      <div
        ref={scrollRef}
        style={{
          display: "flex",
          overflowX: "hidden",
          scrollBehavior: "smooth",
          gap: "20px",
          paddingTop: "40px",
        }}
      >
        {foodItems.map((item, index) => (
          <div
            key={index}
            style={{
              flex: "0 0 auto",
              width: "130px",
              textAlign: "center",
              marginRight: "16px",
            }}
          >
            <img
              src={"/Home/newBg.svg"}
              alt={item.name}
              style={{
                width: 140,
                height: 135,
                borderRadius: "50%",
                objectFit: "cover",
                marginBottom: 8,
                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
              }}
            />
            <p className="mt-2">{item.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HeaderCarousel;
